module.exports = __webpack_public_path__ + "static/media/tractor_yellow.73eb235b.svg";